import { lazy, Suspense, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";

import Loading from "components/Loading";
import useFindContractById from "hooks/api/useFindContractById";
import { useSyncEffect } from "hooks/effects";
import useErrorModalStatusContext from "hooks/useErrorModalStatusContext";
import { getCancelRequestRequestedAt } from "utils/cancelRequestSession";
import { isBrowser, isTablet } from "utils/deviceDetect";

const UsageDetailPresenter = lazy(() =>
  isBrowser
    ? import("pages/UsageDetail/pc/UsageDetailPresenter")
    : isTablet
      ? import("pages/UsageDetail/tb/UsageDetailPresenter")
      : import("pages/UsageDetail/sp/UsageDetailPresenter")
);

const UsageDetailContainer = () => {
  const parameter = useParams();
  const navigate = useNavigate();
  const { contract, error: contractDetailError } = useFindContractById(parameter.id ?? "");

  const { showErrorModal } = useErrorModalStatusContext();
  useSyncEffect(() => {
    if (contractDetailError) {
      showErrorModal({ httpMethod: "get", onPostClose: () => navigate(-1) });
    }
  }, [contractDetailError, navigate, showErrorModal]);

  const requestedAt = contract?.quoteId ? getCancelRequestRequestedAt(contract.quoteId) : undefined;
  const showCancelRequestLink = Boolean(contract?.canCancelRequest);

  const onOpenCancelRequest = useCallback(() => {
    if (contract != null && contract.opportunityId != null && contract.quoteId != null) {
      navigate(`/order/${contract.opportunityId}/estimate/${contract.quoteId}/cancel-request`);
    }
  }, [contract, navigate]);

  return (
    <>
      <Suspense fallback={<Loading />}>
        <UsageDetailPresenter
          contract={contract}
          onBack={() => navigate(-1)}
          showCancelRequestLink={showCancelRequestLink}
          isCancelRequested={requestedAt != null}
          cancelRequestedAt={requestedAt}
          onOpenCancelRequestModal={onOpenCancelRequest}
        />
      </Suspense>
    </>
  );
};

export default UsageDetailContainer;
